import { lightTheme } from '@backstage/theme';

import { buildBuiTheme } from './buildBuiTheme';

/**
 * BUI Light Theme for MUI v4 (Spotify variant)
 *
 * Uses the Spotify light mode values from BUI tokens for the MUI palette.
 * Component overrides use CSS variables that automatically adapt.
 */
export const buiLightTheme = buildBuiTheme({
  type: 'light',
  palette: {
    // Primary - Spotify Green
    primary: {
      main: '#1ed760',
      light: '#3be477',
      dark: '#1abc54',
      contrastText: '#000000', // --bui-fg-solid (black on green)
    },
    // Secondary (using surface colors)
    secondary: {
      main: '#000000',
      light: '#000000',
      dark: '#0d0d0d',
      contrastText: '#ffffff',
    },
    // Error (--bui-fg-danger)
    error: {
      main: '#e22b2b',
      dark: '#e22b2b',
      light: '#f87a7a',
      contrastText: '#ffffff',
    },
    // Warning (--bui-fg-warning)
    warning: {
      main: '#e36d05',
      dark: '#e36d05',
      light: '#ffa42b',
      contrastText: '#000000',
    },
    // Success (--bui-fg-success / Spotify green)
    success: {
      main: '#1db954',
      dark: '#1db954',
      light: '#53db83',
      contrastText: '#000000',
    },
    // Divider (--bui-border in light mode = --bui-gray-3)
    divider: '#d9d9d9',
    // Navigation
    navigation: {
      ...lightTheme.palette.navigation,
      background: '#ffffff', // --bui-bg-surface-1
      color: '#757575', // --bui-fg-secondary / --bui-gray-7
      selectedColor: '#000000', // --bui-fg-primary
      submenu: {
        background: '#ffffff',
      },
    },
    // Text colors
    text: {
      primary: '#000000', // --bui-fg-primary
      secondary: '#757575', // --bui-fg-secondary / --bui-gray-7
      disabled: '#9e9e9e', // --bui-fg-disabled
      hint: '#757575',
    },
    // Background colors (Spotify light)
    background: {
      paper: '#eee', // --bui-bg-surface-1
      default: '#fff', // --bui-bg / --bui-gray-1
    },
    // Action colors
    action: {
      hover: 'rgba(0, 0, 0, 0.04)', // --bui-bg-tint-hover
      hoverOpacity: 0.04,
      disabled: '#9e9e9e', // --bui-fg-disabled
      disabledBackground: '#ececec', // --bui-bg-solid-disabled / --bui-gray-2
      active: '#ffffff', // --bui-bg-surface-1
      focus: 'rgba(0, 0, 0, 0.08)', // --bui-bg-tint-pressed
    },
  },
});
